export const IDM_SERVER_BASE_URL =
    window.IDM_CONFIG?.IDM_SERVER_BASE_URL || '';
